import {getOrFail} from "../utils/common-utils.ts";
import {ItemListItemClass} from "./ItemListItemClass.ts";
import {DateTime} from "luxon";
import {parseDate} from "../date/util.ts";

export class VideoPlayerDetails {
    constructor(
        readonly episodeId: string,
        readonly type: string,
        readonly videoUrl: string,
        readonly videoDuration: string,
        readonly liveDateTime: DateTime | undefined,
        readonly lastDateModified: DateTime | undefined,
        readonly title: string,
        readonly description: string,
        readonly category: string,
        readonly categoryURL: string,
        readonly image: string,
        readonly altImageTxt: string,
        readonly url: string,
        readonly teststream: string,
    ) {
    }

    static createInstanceFromItemListItemClass(ili: ItemListItemClass) {
        return new VideoPlayerDetails(
            ili.episodeId!,
            ili.type!,
            ili.videoUrl!,
            ili.videoDuration!,
            ili.liveDateTime!,
            DateTime.now(), // not available in item lists!!!
            ili.title!,
            ili.description!,
            ili.category!,
            ili.categoryURL!,
            ili.image!,
            ili.altImageTxt!,
            ili.url!,
            ili.testStream!,
        )
    }

    static createInstanceFromDOM(details: DOMStringMap, lang: string) {
        return new VideoPlayerDetails(
            getOrFail(details, "episodeid"),
            getOrFail(details, "type"),
            getOrFail(details, "videourl"),
            getOrFail(details, "videoduration"),
            VideoPlayerDetails.getDate(details, "livedatetime"),
            VideoPlayerDetails.getDate(details, "lastdatemodified"),

            "en" == lang ? getOrFail(details, "title_en_t") : getOrFail(details, "title_fr_t"),
            "en" == lang ? getOrFail(details, "description_en_t") : getOrFail(details, "description_fr_t"),
            "en" == lang ? getOrFail(details, "category_en_t") : getOrFail(details, "category_fr_t"),
            "en" == lang ? getOrFail(details, "categoryurl_en_s") : getOrFail(details, "categoryurl_fr_s"),
            "en" == lang ? getOrFail(details, "image_en_s") : getOrFail(details, "image_fr_s"),
            "en" == lang ? getOrFail(details, "altimagetxt_en_s") : getOrFail(details, "altimagetxt_fr_s"),
            "",
            getOrFail(details, "teststream"),
        );
    }

    private static getDate = (details: DOMStringMap, key: string) => {
        const val = getOrFail(details, key)
        // Server dates are ISO-8601 UTC with millis; the attribute may legitimately be
        // blank (isoOrBlank emits "" when the episode has no such date). Delegate to
        // parseDate so blank/off-contract values become undefined — the same contract
        // the item-list path has — instead of a truthy Invalid DateTime.
        return parseDate(val)
    }
}